import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageSectionItem from "./common/ImageSectionItem"
import ImageTitleItem from "./common/ImageTitleItem"
import SeparatorLine from "./common/SeparatorLine"
import TextGridItem from "./common/TextGridItem"
import HalfTextItem from "./common/HalfTextItem"
import "./Record.css"
import { useEffect } from "react"

const Record = () => {

    useEffect(() => {
        document.title = 'Séneca - Grabación y catalogación'
        window.scrollTo(0, 0)
    }, [])

    return (

        <main className="generic-main">

            <ImageTitleItem
                imageURL="/images/record/grabacion-1.png"
                titleText="Grabación y catalogación"
                icon="bi bi-camera-reels blue-icon"
                subtitleText="Estación de ingesta que permite realizar las funciones de captura y catalogación de las sesiones de una manera sencilla"
            />
            <SliderImageSeparator />

            <ImageSectionItem
                imagePosition="before"
                layout="column"
                imageURL="/images/record/grabacion-2.png"
                isBigImage="true"
            />
            <SeparatorLine />

            <TextGridItem
                textItemArray={[
                    [
                        "Audio",
                        "bi bi-music-note",
                        "Control y registro de todos los micrófonos instalados en la sala. Identificación de los puestos parlamentarios y las peticiones de turno de palabra."],
                    [
                        "Vídeo",
                        "bi bi-camera-reels-fill",
                        "Control y manejo de todas las cámaras instaladas en la sala. Identificación de localización de los puestos parlamentarios."
                    ],
                    [
                        "Votación",
                        "bi bi-envelope-paper",
                        "El sistema dispone de un control de las votaciones donde el alcalde o presidente puede elegir el modo de la misma: manual o automática (iniciar y cerrar la misma manualmente, o con tiempo predefinido). También si es pública o secreta (sentido del voto individual oculto). Las pantallas de resultados geográficos y numéricos, se adaptarán mostrando o no la información dependiendo del modo."
                    ],
                    [
                        "Tiempos",
                        "bi bi-clock",
                        "Además del reloj individual, el sistema contempla el control de sesiones de interpelación al gobierno, con doble reloj para tiempos acumulados: pregunta / réplica + respuesta / contrarréplica."
                    ],
                    [
                        "Presencia",
                        "bi bi-person-check",
                        "El sistema de control de presencia gestiona la permanencia del personal en todas las instalaciones del parlamento permitiendo conocer el tiempo de estancia e identificar si el recinto está vacío."
                    ],
                    [
                        "Control",
                        "bi bi-toggle-on",
                        "El operador dispone del control de todos los elementos audiovisuales de la sala, tanto individualmente como para lanzar secuencias de órdenes. Encender equipos, bajar pantalla, conectar proyector y lanzar DVD, todo ello con una pulsación."
                    ]
                ]}

            />
            <SeparatorLine />

            <HalfTextItem
                textItems={[
                    [
                        "Una ingesta inteligente",
                        [
                            "<p class='middle-section-label'><strong>Sabemos que dentro de un flujo de trabajo se necesitan distintos formatos de archivos de audio o vídeo en función de uso: transcripción, web, streaming en directo, buena calidad de emisión, etc.</strong></p>",
                            "<p class='middle-section-label'>La entrega de clips a los medios mientras se graba la sesión ya no es un problema con Séneca. El sistema simplifica las tareas capturando en alta calidad y creando los proxis necesarios para servir a los distintos tipos de usuario. La solidez del sistema no cambia, se mantiene la tolerancia a fallos de red, y con su base Windows y las tarjetas de captura de vídeo en SDI-HD o SD con audio embebido se mantiene la calidad de producción en los estándares más profesionales.</p>",
                            "<p class='middle-section-label'>El software de captura incluye un códec avanzado de MPEG2 TS para realizar tareas de edición de manera simultánea a la grabación, así como en H264-(AVC).</p>"
                        ]
                    ],
                    [
                        "Una integración activa",
                        [
                            "<p class='middle-section-label'><strong>Séneca permite la integración de la grabadora con su solución de microfonía y votación digital, lo cual hace innecesario mantener distintas bases de datos con la misma información para distintos sistemas.</strong></p>",
                            "<p class='middle-section-label'>Desde el administrador puede controlar la configuración de sus escaños, cargar la base de oradores y registrar las intervenciones de manera automática de acuerdo a la actividad de los micrófonos. También puede agregar contenido al servidor y catalogarlo con posterioridad, lo haya obtenido o no con una grabadora de Séneca.</p>",
                            "<p class='middle-section-label'>Obtenga archivos en distintos formatos de los eventos realizados fuera de la sede o capturados por otros sistemas y súbalos al servidor, él se encargará de convertirlos, indexarlos y almacenarlos, posteriormente podrá catalogarlos y presentarlos en la web de una manera dinámica.</p>"
                        ]
                    ]
                ]}
            />

            <ImageSectionItem
                imagePosition="before"
                layout="column"
                imageURL="/images/record/grabacion-3.png"
                isAnimatedImage="true"
                imageClassName="record-animated-image"
            />

        </main >
    )

}

export default Record